// extracted by mini-css-extract-plugin
export default {"box":"advertisementPage_box__HbAMe"};